export const UserActionTypes = {
    SET_CURRENT_USER: 'SET_CURRENT_USER',
    SET_CURRENT_USER_ID: 'SET_CURRENT_USER_ID',
    LOG_OUT_CURRENT_USER: 'LOG_OUT_CURRENT_USER',
};